import { clsx } from 'clsx'

/**
 * Initials sit ON the type ladder (§2), snapped by avatar size.
 *
 * It was `size * 0.4`, which produced 11.2px / 16px / 33.6px — two of the three
 * off the ladder entirely, and 11.2px is a fractional size the renderer has to
 * hint. Measured on /partidos 2026-08-07: every stacked avatar rendered at
 * 11.2px.
 */
function initialsFontSize(size: number): number {
  if (size <= 24) return 11
  if (size <= 36) return 13
  if (size <= 48) return 16
  if (size <= 64) return 22
  return 32
}

// Circular avatar — photo when available, else initials on an accent-soft fill.
export function Avatar({
  name,
  src,
  size = 40,
  className,
}: {
  name: string
  src?: string | null
  size?: number
  className?: string
}) {
  const initials = name
    .split(' ')
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase()
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center rounded-full overflow-hidden shrink-0',
        'bg-[var(--accent-soft)] text-[color:var(--accent)] font-semibold',
        className,
      )}
      style={{ width: size, height: size, fontSize: initialsFontSize(size) }}
    >
      {src ? (
        <img
          src={src}
          alt={name}
          width={size}
          height={size}
          // Explicit dimensions reserve the box before the image arrives;
          // lazy because avatars are almost always below the fold in a feed.
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
        />
      ) : (
        initials || '?'
      )}
    </span>
  )
}
